module.exports = __webpack_public_path__ + "img/decorative_7.5318d49a.png";